import { Box, Label, Text } from '@medely/ui-kit';
import React from 'react';

export const NoPositionsAndSpecialties = () => {
  return (
    <Box py={4} testId="no-positions-and-specialties">
      <Box pb={0.5}>
        <Label size="m" textAlign="center" testId="no-positions-and-specialties-title">
          No positions and specialties
        </Label>
      </Box>
      <Text size="m" textAlign="center" testId="no-positions-and-specialties-text">
        Positions and specialties help identify shifts that align with your expertise and
        experience.
      </Text>
    </Box>
  );
};
